module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content",
    staticStyle: {
      "background-color": "#EBECF1"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-info"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('form', {
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "fuente col-xs-12 table-responsive"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('table', {
    staticClass: "fuente fs-12 table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "tablaDetalle_info",
      "role": "grid",
      "id": "tablaDetalle"
    }
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.pensionistas), function(item, index) {
    return _c('tr', {
      key: index,
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "sorting_1 table-center-header"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.dni))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.nombres))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.correo))]), _vm._v(" "), _c('td', {
      staticClass: "table-center-header"
    }, [_c('span', {
      staticClass: "badge bg-red",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "data-toggle": "modal",
        "data-target": "#modalAnular"
      },
      on: {
        "click": function($event) {
          return _vm.verAnular(item)
        }
      }
    }, [_vm._v("X\n                                                    ")])])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "fuente col-md-12",
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("\n                                    " + _vm._s(_vm.error.desError) + "\n                                ")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "modalAnular",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('form', [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "fuente modal-body"
  }, [_vm._v("\n                                            Se anulará al pensionista " + _vm._s(_vm.trab.nombres) + "\n                                        ")]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "fuente btn btn-danger fs-13",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.mergeAnular()
      }
    }
  }, [_vm._v("Anular Pensionista")])])])])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "fuente box-title p-t-10"
  }, [_vm._v("MANTENIMIENTO DE PENSIONISTAS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    staticClass: "sorting_asc table-center-header",
    attrs: {
      "aria-label": "ITEM",
      "aria-sort": "ascending",
      "aria-controls": "tablaDetalle",
      "tabindex": "0"
    }
  }, [_vm._v("ITEM")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    attrs: {
      "aria-label": "DNI",
      "aria-controls": "tablaDetalle",
      "tabindex": "0"
    }
  }, [_vm._v("DNI")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    attrs: {
      "aria-label": "NOMBRE COMPLETO",
      "aria-controls": "tablaDetalle",
      "tabindex": "0"
    }
  }, [_vm._v("NOMBRE")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    attrs: {
      "aria-label": "CORREO",
      "aria-controls": "tablaDetalle",
      "tabindex": "0"
    }
  }, [_vm._v("CORREO")]), _vm._v(" "), _c('th', {
    staticClass: "sorting table-center-header",
    attrs: {
      "aria-label": "ANULAR",
      "aria-controls": "tablaDetalle",
      "tabindex": "0"
    }
  }, [_vm._v("\n                                                    ANULAR\n                                                ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('h4', {
    staticClass: "fuente modal-title m-t-10",
    attrs: {
      "id": "myModalLabel"
    }
  }, [_vm._v("¿DESEA ANULAR AL\n                                                PENSIONISTA?")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-41ff2c5c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Pensionistas.vue
// module id = 336
// module chunks = 1